export const MARKET_PATH = "markets/:marketUUID/*";

export const PARTY_MARKET_SECTION_PATH = `/party/:partyUUID/${MARKET_PATH}`;

export const PARTY_SECTION_PATH = "/party/:partyUUID/:section/*";

export const BOT_ROUTE = "/party/:partyUUID/:botType/:uuid/:section";
